<div class="billing-container">
  <!-- Header -->
  <div class="billing-header">
    <div class="title-section">
      <h1 i18n="@@billing.title">Billing</h1>
      <p class="subtitle" i18n="@@billing.subtitle">Manage your subscription and billing</p>
    </div>
  </div>

  <!-- Tabs -->
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0" i18n="@@billing.tab.subscription">Subscription</p-tab>
      <p-tab value="1" i18n="@@billing.tab.plans">Plans</p-tab>
      <p-tab value="2">
        <ng-container i18n="@@billing.tab.invoices">Invoices</ng-container>
        @if (subscriptionService.hasInvoicesRequiringAttention) {
          <i class="pi pi-exclamation-triangle warning-icon"></i>
        }
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-subscription />
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-plans />
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-invoices />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
